import request from '../../../src/utils/request'

export const getSalaryAnomalyInsightOverview = () => {
  return request({
    url: '/addon/salaryAnomalyInsight/overview',
    method: 'get'
  })
}
